/**
 * Modelo de datos para Vehículo
 */

export enum VehicleStatus {
  AVAILABLE = 'AVAILABLE',
  SOLD = 'SOLD',
  RESERVED = 'RESERVED',
  MAINTENANCE = 'MAINTENANCE'
}

export enum FuelType {
  GASOLINE = 'GASOLINE',
  DIESEL = 'DIESEL',
  ELECTRIC = 'ELECTRIC',
  HYBRID = 'HYBRID'
}

export enum TransmissionType {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC',
  SEMI_AUTOMATIC = 'SEMI_AUTOMATIC'
}

export enum CurrencyType {
  USD = 'USD',
  ARS = 'ARS'
}

export enum VehicleCondition {
  NUEVO = 'nuevo',
  USADO = 'usado'
}

export enum VehicleType {
  AUTO = 'auto',
  MOTO = 'moto',
  CAMIONETA = 'camioneta',
  CAMION = 'camion',
  CUATRICICLO = 'cuatriciclo'
}

/**
 * Interface principal del vehículo
 */
export interface Vehicle {
  id: string;
  brand: string;
  model: string;
  year: number;
  price: number;
  mileage: number;
  color: string;
  vin: string; // Vehicle Identification Number
  status: VehicleStatus;
  fuelType: FuelType;
  transmission: TransmissionType;
  engine: string;
  doors: number;
  seats: number;
  description?: string;
  features?: string[];
  images?: string[];
  stock: number;
  // Campos adicionales para compatibilidad con frontend
  currency: CurrencyType;
  condition: VehicleCondition;
  vehicleType: VehicleType;
  licensePlate?: string; // Dominio/Patente
  salesperson?: string; // Vendedor responsable
  entryDate?: string; // Fecha de ingreso
  saleDate?: string; // Fecha de venta
  publicationLink?: string; // Link de la publicación en redes sociales
  vehicleImageLink?: string; // Link de la imagen principal del vehículo
  createdAt: string;
  updatedAt: string;
}

/**
 * DTO para crear un nuevo vehículo
 */
export interface CreateVehicleDto {
  brand: string;
  model: string;
  year: number;
  price: number;
  mileage: number;
  color: string;
  vin: string;
  fuelType: FuelType;
  transmission: TransmissionType;
  engine: string;
  doors: number;
  seats: number;
  description?: string;
  features?: string[];
  images?: string[];
  stock?: number;
  // Campos adicionales
  currency?: CurrencyType;
  condition?: VehicleCondition;
  vehicleType?: VehicleType;
  licensePlate?: string;
  salesperson?: string;
  entryDate?: string;
  publicationLink?: string;
  vehicleImageLink?: string;
}

/**
 * DTO para actualizar un vehículo
 */
export interface UpdateVehicleDto {
  brand?: string;
  model?: string;
  year?: number;
  price?: number;
  mileage?: number;
  color?: string;
  status?: VehicleStatus;
  fuelType?: FuelType;
  transmission?: TransmissionType;
  engine?: string;
  doors?: number;
  seats?: number;
  description?: string;
  features?: string[];
  images?: string[];
  stock?: number;
  // Campos adicionales
  currency?: CurrencyType;
  condition?: VehicleCondition;
  vehicleType?: VehicleType;
  licensePlate?: string;
  salesperson?: string;
  entryDate?: string;
  saleDate?: string;
  publicationLink?: string;
  vehicleImageLink?: string;
  vin?: string;
}

/**
 * Filtros para buscar vehículos
 */
export interface VehicleFilters {
  brand?: string;
  model?: string;
  minYear?: number;
  maxYear?: number;
  minPrice?: number;
  maxPrice?: number;
  status?: VehicleStatus;
  fuelType?: FuelType;
  transmission?: TransmissionType;
  search?: string;
  // Campos adicionales
  vehicleType?: VehicleType;
  condition?: VehicleCondition;
}

